import React, {Component} from 'react'
import './smile.css'
import PropTypes from 'prop-types'
import classNames  from 'classnames'
import {SMILE_SUPER,SMILE_GOOD, SMILE_FAIL} from "../smiles";


class Smile extends Component {

    render() {

        let smileClass = classNames({
            'Smile': true,
            'Smile--active': this.props.isActive,
            'Smile--super': this.props.type === SMILE_SUPER,
            'Smile--good': this.props.type === SMILE_GOOD,
            'Smile--fail': this.props.type === SMILE_FAIL,
        });

        return (
            <div className={smileClass} onClick={this.props.onClick.bind(this, this.props.mark)}>
                    <img className="Smile__image" src={this.props.image} alt={this.props.text}/>
                    <span className="Smile__text">{this.props.text}</span>
            </div>
        );
    }

}

Smile.propTypes = {
    isActive: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default Smile;


// WEBPACK FOOTER //
// ./src/components/smile/index.js